const API = '/api/api_eod_oc.php';

async function api(action, params = {}) {
  const res = await fetch(`${API}?${new URLSearchParams({ action, ...params })}`, { credentials: 'include' });
  const json = await res.json();
  if (!res.ok || json.error) throw new Error(json.error || `HTTP ${res.status}`);
  return json;
}

export const eodOcApi = {
  init: (exch = 'NSE', tp = 'IDO') => api('init', { exch, tp }),
  switchSymbol: (exch, sym, tp) => api('switch_symbol', { exch, sym, tp }),
  expiries: (exch, sym, tp, dt) => api('expiries', { exch, sym, tp, dt }),
  load: ({ exch, sym, tp, dt, exp, days = 30 }) =>
    api('load', { exch, sym, tp, dt, exp, days: String(days) }),
};